<template>
<div class="regional-statistics">
	<div class="modal-window">
		<div class="modal-content">
			<grid>
				<div alt="logo" class="logo" />
			</grid>
			<grid>
				<grid-item size="1/1">
					<chart />
				</grid-item>
			</grid>
			<hr>
			<grid flat>
				<grid-item class="1/1">
					<button class="button green-dark full">Newly Registered Companies & Jobs created against time</button>
				</grid-item>
			</grid>
			<grid>
				<grid-item size="3/7">
					<button class="button primary">Unemployment Rate</button>
				</grid-item>
				<grid-item size="4/7">
					<button class="button primary">2018 Issued Capital by Sector</button>
				</grid-item>
			</grid>
		</div>
	</div>
	<a @click="goToOpportunity()" class="back-button">
		X
	</a>
</div>
</template>

<script>
import chart from '../components/Chart'
export default {
	components: {
		chart
	},
	methods: {
		goToOpportunity() {
			this.$router.push({
				name: 'opportunity',
				hash: '#RegionalStatisticsTab',
				params: {
					opportunityId: this.$route.query.opportunityId
				},
				query: {
					...this.$route.query,
					opportunityId: undefined
				}
			})
		}
	}
}
</script>

<style lang="scss">
.regional-statistics {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 56px;
	right: 0;
	z-index: 3;
	background: #0202029c;

	.modal-window {
		top: 44% !important;
		left: 48% !important;
		width: 40% !important;

		.modal-content {
			background: linear-gradient(to left, rgba(4, 4, 4, 0.51), rgba(50, 67, 80, 0.52));
			padding-bottom: 15px;
			padding-top: 10px;
			border-color: rgba(255, 255, 255, 0.66);

			.logo {
				background: url('../../../assets/images/logo_light.svg');
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
				width: 100px;
			}
		}
		hr {
			margin: 15px;
			width: 520px;
			margin-left: -40px;
		}
		.button {
			width: 100%;
			padding: 6px 13px;
			margin: 4px 0px;
		}
	}

	.back-button {
		position: absolute;
		top: 0;
		right: 0;
		text-decoration: none;
		color: #fff;
		background: #3b9fcf;
		width: 55px;
		height: 55px;
		line-height: 55px;
		font-size: 36px;
		font-weight: 200;
		cursor: pointer;
	}
}
</style>
